export default "__VITE_ASSET__KkGoWkBg__"